<div
  class="app-assistant-banner"
  *ngIf="showContent"
  @fadeAnimation
>
  <div class="container">
    <div class="content-controls-container">
      <div class="content-container">
        <app-assistant-banner-content
          class="content merri-scrollbar-gray"
          [content]="data.content"
        ></app-assistant-banner-content>
        <app-assistant-banner-content-links
          class="content-links"
          [links]="data.content.links"
        ></app-assistant-banner-content-links>
      </div>
      <div
        class="controls-container"
        *ngIf="data.actions"
      >
        <div class="controls">
          <app-assistant-banner-action-buttons
            class="action-buttons"
            [actions]="data.actions"
          ></app-assistant-banner-action-buttons>
        </div>
      </div>

      <button
        class="button-minimize"
        mat-icon-button
        disableRipple
        (click)="onMinimize()"
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>
</div>
